import styled from "styled-components";

export const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding: 24px;
    gap: 24px;
`;

export const ChartContainer = styled.div`
    background: #ffffff;
    border-radius: 8px;
    padding: 16px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);
    margin-bottom: 24px;
`;

export const ChartTitle = styled.h3`
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 4px;
    color: #333;
`;

export const TotalOrdersCount = styled.div`
    font-size: 14px;
    color: #666;
    margin-bottom: 16px;
`;

export const ToggleWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const ToggleOption = styled.div<{ isSelected?: boolean }>`
    padding: 8px 12px;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
    background-color: ${props => props.isSelected ? "#0058A0" : "#F2F4FA"};
    color: ${props => props.isSelected ? "white" : "#333"};
    transition: all 0.2s ease;

    &:hover {
        background-color: ${props => props.isSelected ? "#0058A0" : "#e1e5f0"};
    }
`;

export const ChartHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 16px;
`;

export const TitleSection = styled.div`
    display: flex;
    flex-direction: column;
`;

export const TooltipContainer = styled.div`
    background: #fff;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
`;

export const TooltipLabel = styled.p`
    margin: 0;
`;

export const TooltipValue = styled.p<{ color?: string }>`
    margin: 0;
    color: ${props => props.color || 'inherit'};
`;

export const LegendContainer = styled.div`
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-bottom: 10px;
    margin-top: 10px;
`;

export const LegendItem = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;
`;

export const LegendColorBox = styled.div<{ backgroundColor?: string }>`
    width: 12px;
    height: 12px;
    background-color: ${props => props.backgroundColor || '#000'};
`;

export const LegendText = styled.span`
    color: black;
`; 